import React, { Fragment } from 'react'
import { Typography } from 'antd'
import NewHeader from '../../../components/NewHeader'
const { Title } = Typography
const QuestHeader = ({ t }) => {
  return (
    <Fragment>
      <div className="create-course">
        <div className="create-course__content">
          <Title level={4}>Create Quest</Title>
        </div>
        <NewHeader />
      </div>
    </Fragment>
  )
}

export default QuestHeader
